import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  operation: 'get',
  key: '',
  value: '',
  keyType: 'automatic',
  propertyName: 'value',
  dotNotation: false,
  valueIsJson: false,
  expire: false,
  ttl: 60,
  pattern: '*',
  getValues: false,
  list: '',
  messageData: '',
  tail: true,
  channel: '',
  continueOnError: false,
  // New operation defaults
  sourceArray: '',
  keyField: 'key',
  valueField: 'value',
  keysToGet: '',
  confirmFlush: false,
};

export default defaults;
